/**
 * Free Samples Handler
 * Handles product page redirects for free sample products
 */

class FreeSamplesHandler {
  constructor() {
    this.init();
  }

  init() {
    if (window.location.pathname.includes('/products/')) {
      this.checkProductRedirect();
    }
    this.handleFreeSampleLinks();
  }

  async handleRealSizeProduct(product, productHandle = null) {
    // Metafield namespace: custom, key: real_size_product
    // Check for full size product metafield
    
    // First, try to get from data attribute if product is rendered in DOM
    let realSizeProductUrl = null;
    if (productHandle) {
      const productElement = document.querySelector(`[data-product-handle="${productHandle}"]`);
      if (productElement) {
        realSizeProductUrl = productElement.getAttribute('data-real-size-product-url');
      }
    }
    
    // If not found in DOM, try from product object (for dynamically fetched products)
    // Note: .js endpoint doesn't include metafields, so this will likely be null
    if (!realSizeProductUrl) {
      const metafield = product.metafields?.custom?.real_size_product;
      if (metafield) {
        // Handle product reference metafield (returns product object)
        if (metafield.url) {
          realSizeProductUrl = metafield.url;
        } else if (metafield.value) {
          // If value is a product object
          if (metafield.value.url) {
            realSizeProductUrl = metafield.value.url;
          } else if (typeof metafield.value === 'string' && metafield.value.includes('/products/')) {
            realSizeProductUrl = metafield.value;
          } else if (typeof metafield.value === 'string') {
            // If it's a handle, construct URL
            realSizeProductUrl = `/products/${metafield.value}`;
          }
        } else if (typeof metafield === 'string' && metafield.includes('/products/')) {
          realSizeProductUrl = metafield;
        }
      }
    }
    
    // If still not found and we have a product handle, try fetching from product page
    if (!realSizeProductUrl && productHandle) {
      realSizeProductUrl = await this.fetchMetafieldFromProduct(productHandle);
    }
    
    if (realSizeProductUrl) {
      window.location.href = realSizeProductUrl;
    } else {
      window.location.href = '/';
    }
  }

  /**
   * Fetch metafield value from product page HTML or use alternative method
   * Since .js endpoint doesn't include metafields, we need to parse the product page
   */
  async fetchMetafieldFromProduct(productHandle) {
    try {
      // Try to find the metafield in the DOM first (if product card is rendered)
      const productElement = document.querySelector(`[data-product-handle="${productHandle}"]`);
      if (productElement) {
        const url = productElement.getAttribute('data-real-size-product-url');
        if (url) return url;
      }
      
      // Alternative: Fetch the product page HTML and look for embedded metafield data
      // This is a fallback if the product isn't rendered in the current page
      const response = await fetch(`/products/${productHandle}`);
      if (!response.ok) return null;
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Look for data attribute in the HTML
      const element = doc.querySelector(`[data-product-handle="${productHandle}"]`);
      if (element) {
        return element.getAttribute('data-real-size-product-url');
      }
      
      // Look for JSON script tag with metafield data
      const scriptTag = doc.querySelector('script[data-product-metafields]');
      if (scriptTag) {
        try {
          const data = JSON.parse(scriptTag.textContent);
          return data.real_size_product;
        } catch (e) {
          console.error('Error parsing metafield data:', e);
        }
      }
      
      return null;
    } catch (error) {
      console.error('Error fetching metafield:', error);
      return null;
    }
  }

/**
   * Check if current product should redirect
   * If product has metafield 'real_size_product', redirect to that product
   * Otherwise redirect to home page
  */
  async checkProductRedirect() {
    try {
      // Get product handle from URL
      const pathParts = window.location.pathname.split('/');
      const productHandle = pathParts[pathParts.indexOf('products') + 1];
      
      if (!productHandle) return;

      // Fetch product data
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) return;
      
      const product = await response.json();
      
      if (product.price === 0) {
        await this.handleRealSizeProduct(product, productHandle);
      }
    } catch (error) {
      console.error('Error checking product redirect:', error);
    }
  }


  /**
   * Handle clicks on free sample product links
   */
  handleFreeSampleLinks() {
    document.addEventListener('click', async (e) => {
      const link = e.target.closest('a[href*="/products/"]');
      if (!link) return;

      // Extract product handle from link
      const href = link.getAttribute('href');
      const match = href.match(/\/products\/([^\/\?#]+)/);
      if (!match) return;

      const productHandle = match[1];

      try {
        // Check if this product is a free sample
        const response = await fetch(`/products/${productHandle}.js`);
        if (!response.ok) return;
        
        const product = await response.json();
        
        // If it's a free sample (price is 0), handle redirect
        if (product.price === 0) {
          e.preventDefault();
          
          await this.handleRealSizeProduct(product, productHandle);
        }
      } catch (error) {
        console.error('Error checking product link:', error);
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FreeSamplesHandler();
  });
} else {
  new FreeSamplesHandler();
}

function initFreeSamplesSwiperOnce(){
  const sel = '.free-samples .product-recommendations__body';
  function mount(){
    const el = document.querySelector(sel);
    if (!el || el.classList.contains('swiper-initialized')) return;
    new Swiper(sel, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: true,
      grabCursor: true,
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }

  // If this block appears inside a cart drawer/section that re-renders, observe and (re)mount
  const obs = new MutationObserver(mount);
  obs.observe(document.documentElement, { childList: true, subtree: true });
}

initFreeSamplesSwiperOnce();

